import template from './sw-cms-el-preview-acris-faq-single.html.twig';
import './sw-cms-el-preview-acris-faq-single.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-acris-faq-single', {
    template
});
